export function stripNullableValues<
    T extends {
        [K in keyof T]: T[K] | null | undefined;
    },
>(
    object: T,
): {
    [K in keyof T]: NonNullable<T[K]>;
} {
    const entries = Object.entries(object).filter(([_key, value]) => {
        return value != null;
    });

    return Object.fromEntries(entries) as {
        [K in keyof T]: NonNullable<T[K]>;
    };
}
